<app-feature-details-grid>
  <app-feature-list-container
    title="{{ '+INSTALLATIONS.INSTALLATION.PV_HEATER.DETAILS.TITLE' | translate }}"
    [overlayType]="availableOverlays.PvImmersionHeaterDetails"
  >
    <app-feature-list-item
      *ngIf="inverterModel$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.PV_HEATER.DETAILS.MODEL' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="inverterManufacturer$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.PV_HEATER.DETAILS.MANUFACTURER' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="inverterEtn$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.PV_HEATER.DETAILS.SERIAL_NUMBER' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>

<app-feature-details-grid>
  <app-feature-list-container
    title="{{ '+INSTALLATIONS.INSTALLATION.SOLARLOG.GATEWAY.TITLE' | translate }}"
  >
    <app-feature-list-item
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.GATEWAY.NAME' | translate"
      [value]="gatewayName$ | async | dash"
      [attr.data-feature]="'gatewayName'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="gatewayEtn$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.GATEWAY.SERIAL_NUMBER' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="gatewayFirmware$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.GATEWAY.FIRMWARE' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>
